// @flow
import React from 'react'

type Props = {}

class Chart extends React.Component<Props> {
    render() {
        return (
            <div>
                <img src={'/static/er2_ficus/img/refugee_chart.png'} />
            </div>
        )
    }
}

export default Chart
